export const addToCalendarPopup = () => {
  if (window.location.hash.includes('#N4NSNWebinar')) {
    $('#add-to-calendar-popup').fadeIn(150).css('display', 'flex');

    $('body').addClass('locked');
  }

  // Display selected calendar date when form reloads
  document.addEventListener('gform/post_render', (event) => {
    setTimeout(() => {
      if (window.selectedDate) {
        document.querySelector('.selected-date').innerText =
          'Selected date: ' + window.selectedDate;
      }
    }, 100);
  });

  //lightbox
  document
    .querySelectorAll("a[href='#add-to-calendar-popup']")
    .forEach((link) => {
      link.addEventListener('click', (e) => {
        const date = e.target.getAttribute('data-date');
        const form = document.querySelector('#add-to-calendar-popup');

        // Display selected date when user clicks 'Add to calendar'
        form
          .querySelectorAll('.info-sessions div.gchoice')
          .forEach((choice) => {
            if (choice.querySelector('label').innerText == date) {
              choice.querySelector('input').checked = true;
              form.querySelector('.selected-date').innerText =
                'Selected date: ' + date;
              window.selectedDate = date;
            }
          });

        $('#add-to-calendar-popup').fadeIn(150).css('display', 'flex');

        $('body').addClass('locked');
      });
    });

  $('body').on('click', '.popup-closer', function () {
    $('#add-to-calendar-popup').hide();
    $('body').removeClass('locked');

    document
      .querySelectorAll('#add-to-calendar-popup .gfield_checkbox input')
      .forEach((input) => {
        input.checked = false;
      });

    return false;
  });

  $('body').on('click', '#add-to-calendar-popup', function () {
    $('#add-to-calendar-popup').hide();
    $('body').removeClass('locked');

    document
      .querySelectorAll('#add-to-calendar-popup .gfield_checkbox input')
      .forEach((input) => {
        input.checked = false;
      });
    return false;
  });

  $('body').on('click', '.popup-contents', function (e) {
    e.stopPropagation();
  });

  $(document).on('keydown', function (event) {
    if (event.key == 'Escape') {
      $('#add-to-calendar-popup').hide();
      $('body').removeClass('locked');
    }
  });
};
